import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import _JSXStyle from "styled-jsx/style";
import Image from 'next/image';
import Img from '@@client/components/Img';
import Carousel from '@@client/components/Carousel';
import PartSearchForm from '@@client/parts/PartSearchForm';
var spacing = {
  topPadding: 70,
  bottomPadding: 42,
  lrPadding: 42,
  leftLinePadding: 18,
  lineWidth: 3
};
export var Slide = function Slide(_ref) {
  var children = _ref.children,
      _ref$src = _ref.src,
      src = _ref$src === void 0 ? null : _ref$src,
      _ref$imageUrl = _ref.imageUrl,
      imageUrl = _ref$imageUrl === void 0 ? null : _ref$imageUrl,
      alt = _ref.alt,
      heading = _ref.heading,
      _ref$subContent = _ref.subContent,
      subContent = _ref$subContent === void 0 ? null : _ref$subContent;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs("div", {
      className: "jsx-3833206763" + " " + 'slide pad-right-gutter',
      children: [/*#__PURE__*/_jsx("div", {
        className: "jsx-3833206763" + " " + 'm--bg--img',
        children: src ? /*#__PURE__*/_jsx(Image, {
          layout: "fill",
          src: src,
          alt: alt
        }) : /*#__PURE__*/_jsx(Img, {
          src: imageUrl,
          alt: alt
        })
      }), /*#__PURE__*/_jsxs("div", {
        className: "jsx-3833206763" + " " + 'content',
        children: [heading ? /*#__PURE__*/_jsx("h2", {
          className: "jsx-3833206763" + " " + 'h--xl--white',
          children: heading
        }) : null, children, subContent ? /*#__PURE__*/_jsx("div", {
          className: "jsx-3833206763" + " " + 'sub-content',
          children: subContent
        }) : null]
      })]
    }), /*#__PURE__*/_jsx(_JSXStyle, {
      id: "3833206763",
      children: [".slide.jsx-3833206763{position:relative;padding:30px 10px 10px;}", "@media(min-width:576px){.slide.jsx-3833206763{padding:".concat(spacing.topPadding, "px ").concat(spacing.lrPadding, "px ").concat(spacing.bottomPadding, "px ").concat(spacing.lrPadding + spacing.leftLinePadding, "px;}}"), ".slide.jsx-3833206763::before{content:'';display:none;position:absolute;top:".concat(spacing.topPadding, "px;bottom:").concat(spacing.bottomPadding, "px;left:").concat(spacing.lrPadding, "px;width:").concat(spacing.lineWidth, "px;background:#FFDD15;}"), "@media(min-width:576px){.slide.jsx-3833206763::before{display:block;}}", ".slide.jsx-3833206763::after{content:'';position:absolute;width:100%;height:100%;left:0;top:0;background:-webkit-gradient(linear,left top,right top,from(#0F0D3D),to(rgba(34,59,129,0.12)));background:linear-gradient(left,#0F0D3D,rgba(34,59,129,0.12));z-index:-1;}", ".slide.jsx-3833206763 .content.jsx-3833206763{max-width:520px;margin-bottom:40px;color:#FFDD15;font-size:1.5rem;}", ".slide.jsx-3833206763 .sub-content.jsx-3833206763{margin-top:15px;font-size:0.9375rem;}", ".slide.jsx-3833206763 a:not(.btn){color:white;}", ".slide.jsx-3833206763 a:not(.btn):hover{color:#468EE5;}"]
    })]
  });
};
export default function SearchAndSlider(_ref2) {
  var children = _ref2.children,
      partTypeSlug = _ref2.partTypeSlug;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs("div", {
      className: "jsx-2654259311" + " " + 'container',
      children: [/*#__PURE__*/_jsx("div", {
        className: "jsx-2654259311" + " " + 'pad-left-gutter m--gradient--blue--medium part-search',
        children: /*#__PURE__*/_jsx("div", {
          className: "jsx-2654259311" + " " + 'inner',
          children: /*#__PURE__*/_jsx(PartSearchForm, {
            partTypeSlug: partTypeSlug
          })
        })
      }), /*#__PURE__*/_jsx("div", {
        className: "jsx-2654259311" + " " + 'the-carousel',
        children: /*#__PURE__*/_jsx(Carousel, {
          autorotate: 8000,
          label: "Feature Slider",
          trackId: "home-header-slider-track",
          renderNextPrevControls: false,
          children: children
        })
      })]
    }), /*#__PURE__*/_jsx(_JSXStyle, {
      id: "2654259311",
      children: [".container.jsx-2654259311{display:-webkit-box;display:-ms-flexbox;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:reverse;-ms-flex-direction:column-reverse;-webkit-flex-direction:column-reverse;-ms-flex-direction:column-reverse;flex-direction:column-reverse;}", "@media(min-width:768px){.container.jsx-2654259311{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;-webkit-flex-direction:row;-ms-flex-direction:row;flex-direction:row;}}", ".container.jsx-2654259311 .carousel,.container.jsx-2654259311 .track,.container.jsx-2654259311 .slides{height:100%;}", ".part-search.jsx-2654259311{padding-top:".concat(spacing.topPadding, "px;padding-right:").concat(spacing.lrPadding, "px;padding-bottom:").concat(spacing.bottomPadding, "px;}"), "@media(max-width:575px){.part-search.jsx-2654259311{padding:10px;}}", "@media(min-width:576px) and (max-width:767px){.part-search.jsx-2654259311{padding-left:".concat(spacing.lrPadding, "px;}}"), "@media(min-width:576px) and (max-width:767px){.part-search.jsx-2654259311 .inner.jsx-2654259311{max-width:500px;margin:0 auto;}}", "@media(min-width:768px){.part-search.jsx-2654259311 .inner.jsx-2654259311{min-width:215px;}}", "@media(min-width:992px){.part-search.jsx-2654259311 .inner.jsx-2654259311{min-width:280px;}}", "@media(max-width:575px){.part-search.jsx-2654259311 button{width:100%;}}", ".the-carousel.jsx-2654259311{position:relative;overflow:hidden;width:100%;}", ".the-carousel.jsx-2654259311::before{content:'';display:block;height:100%;background:black;width:1px;position:absolute;left:0;top:0;z-index:1;}", ".the-carousel.jsx-2654259311 .indicators{position:absolute;bottom:10px;left:10px;}", "@media(min-width:576px){.the-carousel.jsx-2654259311 .indicators{bottom:".concat(spacing.bottomPadding - 8, "px;left:").concat(spacing.lrPadding + spacing.leftLinePadding - 8, "px;}}"), ".the-carousel.jsx-2654259311 .indicator{margin-right:7px;}", ".the-carousel.jsx-2654259311 .indicator:last-child{margin-right:0;}", ".the-carousel.jsx-2654259311 .indicator:after{border-color:#FFDD15;}", ".the-carousel.jsx-2654259311 .indicator:hover:after{background-color:#FFDD15;}", ".the-carousel.jsx-2654259311 .indicator.is-current:after{background-color:#FFDD15;}"]
    })]
  });
}